<template lang="pug">
b-container#app(fluid).p-0
  b-navbar(variant="light")
    b-navbar-brand(to="/" ) Autotask REST API Explorer
    b-collapse(id="nav-collapse" is-nav)
      b-navbar-nav
        b-nav-item(to="/" ) Home
        b-nav-item(to="/explore") Explore
  b-overlay(:show="has_global_error")
    template( #overlay )
      div.text-center.text-danger
        b-icon-exclamation-triangle
        p {{global_error}}
    router-view
    .d-flex.justify-content-center
       b-link(href="https://www.apigrate.com" target="_blank")
          b-img(src="https://apigrate-static-content.s3-us-west-2.amazonaws.com/brand/apigrate-rect-logo-bitter-transp.png" style="max-width: 100px;")
       small.mt-2 &copy; 2020-2021 Apigrate LLC
</template>

<script>
import {BIcon, BIconPersonFill} from 'bootstrap-vue';
import { mapGetters } from 'vuex'
export default {
  components: {
    BIcon,
    BIconPersonFill,
  },

  mixins: [],

  computed: {
    ...mapGetters(['message','error','errors','busy','global_error','has_error','has_global_error','has_message',]),
  },

  created(){
   
  },
}
</script>
